// extracted by mini-css-extract-plugin
module.exports = {"userNameBox":"antd-pro-containers-company-views-styles-userNameBox"};